__turbopack_context__.v({
  "component__btn": "DynamicButton-module__vP9Ieq__component__btn",
});
